
/**
 * State for the Fare Information
 *
 * @export
 * @class State
 */
export class State {
	flightFareInformation: any;
}

export const initialState: State = {
	flightFareInformation: null
};
